var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0259 28.8611H4.97246C2.22985 28.8611 0 26.6295 0 23.887V17.5416C0 17.1908 0.284102 16.9067 0.634864 16.9067C0.985626 16.9067 1.26973 17.1908 1.26973 17.5416V23.887C1.26973 25.9297 2.93147 27.5914 4.97258 27.5914H27.026C29.0687 27.5914 30.7305 25.9297 30.7305 23.887V8.97409C30.7305 6.93143 29.0687 5.26965 27.026 5.26965H4.97258C2.92992 5.26965 1.26973 6.93139 1.26973 8.97409C1.26973 9.32485 0.985626 9.60895 0.634864 9.60895C0.284102 9.60895 0 9.32485 0 8.97409C0 6.23147 2.23155 4 4.97246 4H27.0259C29.7685 4 32 6.23155 32 8.97409V23.887C32 26.6296 29.7684 28.8611 27.0259 28.8611Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4685 9.39485C29.3066 9.08377 28.9225 8.96314 28.6114 9.12662L15.9982 15.715L3.38832 9.12499C3.07723 8.9631 2.69474 9.08214 2.53124 9.39322C2.36935 9.7043 2.48839 10.0884 2.79947 10.2503L15.7048 16.9927C15.7968 17.0419 15.8984 17.0657 15.9984 17.0657C16.1 17.0657 16.2 17.0419 16.292 16.9927L29.199 10.2503C29.5101 10.0884 29.6304 9.70596 29.4685 9.39485Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eab14d82dc574197ea3dc084c3db950a.svg";
export { ForwardRef as ReactComponent };